import React, { useState, useEffect } from 'react'
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd'
import styles from './index.less'
import { print } from "@/utils/printUtils"
import moment from 'moment'
import { DPP_TREATMENT_PATH_PHYSIOLOGICAL } from '@/utils/consts'

const { TextArea } = Input

const PrintModal = ({
  taskDetail = {},
  info = {},
  visible,
  ...other
}) => {
  const [currentInfo, setCurrentInfo] = useState({})

  useEffect(() => {
    if (info) {
      setCurrentInfo({ ...info })
    }
  }, [info])


  const handlePrint = () => {
    const printContent = document.getElementById("printDetails3").parentNode
    setTimeout(() => {
      print(printContent)
    }, 1500)
  }

  const modalProps = {
    visible: visible,
    // onCancel,
    width: 800,
    okText: '打印',
    ...other
  }

  const handleChange = (key, value) => {
    let newInfo = { ...currentInfo }
    newInfo[key] = value
    setCurrentInfo({ ...newInfo })
  }

  return (
    <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>
      <div id='printDetails3'>
        <div className={styles.BSPPrint}>
          <h2 className={'print-title'} style={{ textAlign: 'center' }}>{currentInfo.docName}</h2>
          <div className={'print-sub-title'} style={{ display: 'flex', justifyContent: 'space-between', lineHeight: '28px', fontSize: '14px', color: '#40a9ff' }}>
            <div>来访者姓名：<TextArea style={{ width: 60, marginBottom: 5 }} value={currentInfo.customerName} autoSize={{ minRows: 1 }} onChange={e => handleChange('customerName', e.target.value)} /></div>
            <div>心理师姓名：<TextArea style={{ width: 60, marginBottom: 5 }} value={currentInfo.psychologistName} autoSize={{ minRows: 1 }} onChange={e => handleChange('psychologistName', e.target.value)} /></div>
            <div>日期时间：<TextArea style={{ width: 80, marginBottom: 5 }} value={currentInfo.serveDate} autoSize={{ minRows: 1 }} onChange={e => handleChange('serveDate', e.target.value)} /></div>
            <div>第<TextArea style={{ width: 30, marginBottom: 5 }} value={currentInfo.count} autoSize={{ minRows: 1 }} onChange={e => handleChange('count', e.target.value)} />次</div>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className='title'>
              <div>{currentInfo.columnOneTitle}</div>
            </h3>
            <div style={{ padding: '8px 16px', border: '1px solid #e8e8e8' }}>
              <TextArea value={currentInfo.columnOneContent} autoSize={{ minRows: 10 }} onChange={e => handleChange('columnOneContent', e.target.value)} />
            </div>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className='title'>
              <div>{currentInfo.columnTwoTitle}</div>
            </h3>
            <div style={{ padding: '8px 16px', border: '1px solid #e8e8e8' }}>
              <TextArea value={currentInfo.columnTwoContent} autoSize={{ minRows: 10 }} onChange={e => handleChange('columnTwoContent', e.target.value)} />
            </div>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className='title'>
              <div>{currentInfo.columnThreeTitle}</div>
            </h3>
            <div style={{ padding: '8px 16px', border: '1px solid #e8e8e8' }}>
              <TextArea value={currentInfo.columnThreeContent} autoSize={{ minRows: 10 }} onChange={e => handleChange('columnThreeContent', e.target.value)} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default Form.create()(PrintModal)
